export default class CreateAuditDto {
	public userAccountId = '';
	public auditType = '';
	public description = '';
	public callerApplicationId = '';
}